import { useState } from 'react';

import clsx from 'clsx';
import { Button } from 'react-bootstrap';
import { BsToggles } from 'react-icons/bs';

import FilterByActivities from './filters/FilterByActivities';
import FilterByCountries from './filters/FilterByCountries';
import FilterByDifficultyLevel from './filters/FilterByDifficultyLevel';
import FilterByMonth from './filters/FilterByMonth';
import TextSearch from './filters/TextSearch';
import styles from './TripSearchForm.module.scss';

export default function TripSearchForm() {
  const [showAllFilters, setShowAllFilters] = useState(false);

  return (
    <div
      className={clsx(
        styles.container,
        showAllFilters ? styles.containerWitHFullScreen : undefined,
      )}
    >
      <h4
        className={clsx(
          styles.title,
          showAllFilters ? undefined : styles.titleHiddenOnMobile,
        )}
      >
        Find your next adventure
      </h4>

      <div className={styles.controls}>
        <div className={styles.searchBoxContainer}>
          <div className={styles.searchBox}>
            <TextSearch />
          </div>
          <div className={styles.toggleButton}>
            <Button
              variant="outline-primary"
              onClick={() => {
                setShowAllFilters((p) => !p);
              }}
            >
              <BsToggles size="21" />
            </Button>
          </div>
        </div>

        <div
          className={clsx(
            styles.filterContainer,
            showAllFilters ? styles.showOnMobileOnly : '',
          )}
        >
          <FilterByActivities
            operator="or"
            attribute="trip.activities"
            limit={50}
          />

          <FilterByDifficultyLevel
            operator="or"
            attribute="trip.difficultyLevel"
          />

          <FilterByCountries operator="or" attribute="country" limit={50} />

          <FilterByMonth />
        </div>
      </div>
      {showAllFilters && (
        <div className={styles.clearFilters}>
          <Button
            variant="outline-primary"
            onClick={() => {
              setShowAllFilters(false);
            }}
          >
            Show trips
          </Button>
        </div>
      )}
    </div>
  );
}
